import { useContext } from 'react';
import { Navigate, Outlet } from 'react-router';

import { AuthContext } from '../context/auth-context.tsx';
import { Loading } from '../loading.tsx';

export const OwnerOrAdminRoute = () => {
  const { user, loading } = useContext(AuthContext);

  if (loading) return <Loading />;

  // Allow access if user is either an admin or an owner
  if (user && !user.isAdmin && !user.isOwner) {
    return <Navigate to='/' />;
  }

  return <Outlet />;
};
